import { faCaretRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Link } from '../Link'

import FacebookLogo from '../../img/facebook-logo.svg'
import './styles.css'

export class Footer extends React.Component {
  render() {
    return (
      <footer className="footer mt-8 pt-5 pb-5">
        <div className="layout-body">
          <div className="grid">
            <div className="col-3_sm-6 mb-1">
              <h5 className="mb-0-5">Help</h5>
              <div>
                <FooterLink text="FAQ" link="/faq" />
                <FooterLink text="Blog" link="/resource-center" />
              </div>
            </div>
            <div className="col-3_sm-6 mb-1">
              <h5 className="mb-0-5">Company</h5>
              <div>
                <ExternalFooterLink text="Careers" link="https://blink-lending.workable.com/" />
              </div>
            </div>
            <div className="col-3_sm-6 mb-1">
              <h5 className="mb-0-5">Terms</h5>
              <div>
                <FooterLink text="Privacy" link="/privacy-policy" />
                <ExternalFooterLink text="T&amp;C's" link="/terms-and-conditions" />
              </div>
            </div>
            <div className="col-3_sm-6 mb-1">
              <h5 className="mb-0-5">Follow</h5>
              <div>
                <a href="https://www.facebook.com/blinkmortgage" className="footer-link">
                  <FacebookLogo className="footer-facebook-logo" />
                </a>
              </div>
            </div>
          </div>
          <div className="mb-2">
            <p className="text-x-small">
              Blink services are provided at no cost to you, we will receive a fee from the lender
              once the mortgage is complete.
            </p>
            <p className="text-x-small">Blink is a trading style of Blink Lending Solutions Inc.</p>
            <p className="text-x-small">
              Licenced By Verico Compass Mortgage Group Canada Mortgage Direct.
            </p>
          </div>
          <p className="text-x-small">100-1721 10th Ave. SW Calgary, AB T3C 0K1, 403-250-2150</p>
        </div>
      </footer>
    )
  }
}

const ExternalFooterLink = (props: { text: string; link: string }) => (
  <a href={props.link} className="footer-link">
    {props.text} <FontAwesomeIcon icon={faCaretRight} className="ml-0-5" />
  </a>
)

const FooterLink = (props: { text: string; link: string }) => (
  <Link to={props.link} className="footer-link">
    {props.text} <FontAwesomeIcon icon={faCaretRight} className="ml-0-5" />
  </Link>
)
